import { filter } from 'rxjs/operators';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { SponserService } from '../../Services/sponser.service';
import { ActivatedRoute } from '@angular/router';
import {ISponserData,ITblSponser,ITbl_Products,ITbl_SponserContacts, SponsorProduct} from '../../Models/sponser-data'
import { Router } from '@angular/router';
import { CodeListValues } from '../../Models/country-data';
import { AbstractControl, FormBuilder, FormGroup, NgForm, ValidationErrors, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { NgStyle } from '@angular/common';
import { LoaderService } from 'src/app/Loader/loader.service';
import { ActiveInActiveStatus,StatusCodes,Dateformat,breadcrumnsCodes, FileExtension, AuditIdentifier, AuditLogModule } from 'src/app/shared/constants/global.constants';
import { BreadcrumbService } from 'src/app/shared/Breadcrumb/breadcrumb.service';
import { Privileges } from 'src/app/shared/constants/privileges.constants';
import { PrivilegeService } from 'src/app/Reusable/privilege.service';
import { ProductFilterDetails } from '../../Models/getSponserFilter';
import { prod } from 'mathjs';
import { DatePipe } from '@angular/common';
import FileSaver from 'file-saver';
import { AuditLogModel } from 'src/app/shared/ModelComparison/audit.log.response.model';
import { AuditLogService } from 'src/app/shared/ModelComparison/audit.log.service';


interface City {
  name: string;
  code: string;
}

@Component({
  selector: 'app-viewsponsor',
  templateUrl: './viewsponsor.component.html',
  styleUrls: ['./viewsponsor.component.css']
})
 
export class ViewsponsorComponent  implements OnInit {

 

  value:string="";
  sponserId:number=0;

  selectedCity1!: City[];
  selectedOption: string = 'Actions';
  noOfSuppliersAreLinkedwithSponserId: any;
  StatusMappingId: any;
  sponserListinfo:ITblSponser={};
  sponserstatusname: any;
  editPrivilege:boolean=false;
  ExportPrivilege:boolean=false;
  totalRecordCount: number = 0;
  filteredRecordCount: number = -1;
  productFormGroup: FormGroup;
  constructor(
    private confirmationService: ConfirmationService, 
    private messageService: MessageService, 
    private service:SponserService,
    private route: ActivatedRoute,
    private router:Router,
    private privilegeService: PrivilegeService,
    private loaderService: LoaderService,private breadcrumbService: BreadcrumbService,
    private datePipe: DatePipe, private fb: FormBuilder,  private auditLogService:AuditLogService,
    )

     {
       this.productFormGroup = this.fb.group({
            productName: ['', [Validators.required,Validators.maxLength(30),this.notOnlySpacesValidator]],
            productStatus:['',[Validators.required]],
          });
     }

  _dateformart :any;
  SponserId:any;
  SponserName:any;
  Address:any;
  NotesandComments:any;
  sponserscontact:any[]=[];
  sponserContactList:ITbl_SponserContacts[]=[];
  productList:ITbl_Products[]=[];
  products:ITbl_Products={};
  createdBy: any;
  createdDateAndTime: any;
  UpdatedBy: any;
  UpdatedByAndTime: any;
  _enumBreadcrumb :any;
  statusData:any;
  productSubmitted=false;
  uniqueProductNameMessage=false;
  displayAddProductDialog:boolean=false;
  @ViewChild('dt') table: any;
 notOnlySpacesValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value && control.value.trim() === '') {
       return { 'onlySpaces': true };
     }
     return null;
   }
  ngOnInit() {
    this._enumBreadcrumb=breadcrumnsCodes;
    this.generateBreadcrumb(this._enumBreadcrumb.EVSP);
    this._dateformart=Dateformat;
    this.route.params.subscribe(params => {
      
      this.sponserId=+params['sponserId'] //log the value of id
    });
    
    this.GetSponserStatus();
    this.BindPrivileges();
    this.loaderService.hidefinalLoader();// hide after 4 seconds even get any error
   }
  
   sponserInfo :any[]=[]
   getSponserData(sponserId:number){
     this.loaderService.showLoader();
   this.service.getSponserData(sponserId).subscribe(
    res=>{
      
      this.loaderService.hideLoader();
      this.sponserInfo=res.data.sponserInfo;
      this.SponserId=res.data.sponserInfo.sponserId;
      this.SponserName=res.data.sponserInfo.name;

      this.auditLogService.logViewWithFilters('View Sponsor',this.SponserId || AuditIdentifier.SponsorDetails,AuditLogModule.Sponsorservice,{
        'Sponsor': this.SponserName
      });

      this.Address=res.data.sponserInfo.address;
      this.StatusMappingId=res.data.sponserInfo.statusMappingId;
      this.Address = this.Address ? this.Address.replace(/\n/g, "<br>") : this.Address;
      var filteredStatus = this.statusData.filter((status: any) => status.id ==  this.StatusMappingId);
          if (filteredStatus != undefined && filteredStatus != null && filteredStatus.length > 0) {
              this.sponserstatusname = filteredStatus[0].name;
          }  
      this.NotesandComments=res.data.sponserInfo.notesAndComments;
      this.NotesandComments = this.NotesandComments ? this.NotesandComments.replace(/\n/g, "<br>") : this.NotesandComments;
      this.UpdatedByAndTime = res.data.sponserInfo.updatedDate;
      this.UpdatedBy =this.privilegeService.getUserName(res.data.sponserInfo.updatedBy) ;
      this.createdBy =this.privilegeService.getUserName(res.data.sponserInfo.createdBy); 
      this.createdDateAndTime = res.data.sponserInfo.createdDate;
      this.sponserContactList=res.data.sponserContacts;
       this.allProducts = res.data.products || [];
       this.productList = [...this.allProducts];
      
      const statusMap = new Map<number, string>();
      this.statusData.forEach((status: { id: number; name: string; }) => {
      statusMap.set(status.id, status.name);
      });

      this.productList.forEach((product: any) => {
      const statusId = Number(product.statusMappingId);
      product.status = statusMap.get(statusId) || 'Unknown';
      product.createdBy= this.privilegeService.getUserName(product.createdBy);
      product.updatedBy=this.privilegeService.getUserName(product.updatedBy);
});

       this. totalRecordCount=this.productList.length;
       this.filteredRecordCount=this.productList.length;

      this.generateBreadcrumb(this._enumBreadcrumb.EVSP,this.SponserName)
         });
  }
  BindPrivileges(){
    const hasPermission = (privilege: Privileges) => this.privilegeService.hasPermission(privilege);
    this.editPrivilege = hasPermission(Privileges.EditSponsor);
    this.ExportPrivilege = hasPermission(Privileges.ExportlistofSponsors);
  }
  orginalStatusData:any;
  GetSponserStatus() {
    this.service.getCodeListData(3, 'Sponser').subscribe(
      res => {
        if (res.data.length > 0) {//Matching the sponser Details status id with code list
          this.statusData=res.data;
          this.orginalStatusData=res.data
          this.getSponserData(this.sponserId);
              
        }

      }
    );
  }
 
generateBreadcrumb(component?:string,recordName?:string)
{
  this.breadcrumbService.generateBreadcrumb(component,recordName);
}
getBreadcrumbs(): MenuItem[] {
  return this.breadcrumbService.getBreadcrumbs();
}

async onOptionChange(): Promise<void> {
  try {
    if (this.selectedOption === 'Edit') {
      await this.router.navigate(['/editsponsor', this.sponserId]);
    }
  } catch (error) {
    console.log(error);
  }
}

  BackToList() {
    this.router.navigate(['/sponsor']);
  }
displayProductDialog: boolean = false;
originalProductData: any;




productFilterDetailsModel=new ProductFilterDetails(); 

  ClearFilters() {
    this.productFilterDetailsModel = {
      ProductName: '',
      longName: '',
      genericName: '',
      internalName: '',
      tradeName: ''
    }
  this.productList = [...this.allProducts];
  this.filteredRecordCount = this.productList.length;

  }
allProducts:any[] = [];
 onfilter(event: any) {
    this.productList = [...this.allProducts];

      const productSearch = this.productFilterDetailsModel.ProductName?.toLowerCase();

      if (!productSearch) {
      this.productList = [...this.allProducts];
      } 
    else {
      this.productList = this.productList.filter(a =>
      a.productName?.toLowerCase().includes(productSearch) ||
      a.longName?.toLowerCase().includes(productSearch) ||
      a.genericName?.toLowerCase().includes(productSearch) ||
      a.internalName?.toLowerCase().includes(productSearch) ||
      a.tradeName?.toLowerCase().includes(productSearch)
    );
    
    }
    this.filteredRecordCount = this.productList.length;
     this.table.first = 0;
  }
selectedProducts: any;
isChecked: boolean = true;
CheckboxEnabled() {
  if (this.selectedProducts.length > 0) {
    this.isChecked = false;
  }
  else {
    this.isChecked = true;
  }
}
selectedRecordsToExpotToExcel: any[] = [];

ExportProductData(){
    this.selectedRecordsToExpotToExcel =this.selectedProducts;
    const dataToExport = this.selectedRecordsToExpotToExcel.map((product) => {
          return {
            'Product Name': product.productName,
            'Long Name': product.longName,
            'Generic Name': product.genericName,
            'Internal Name':product.internalName,
            'Trade Name':product.tradeName,
            'Lifecycle State' : this.statusData.find((status: any) => status.id ==  product.statusMappingId).name ,
            'Modified By' : product.updatedBy,
            'Modified Date and Time':product.updatedDate!=null?this.convertDateTimeFormat(product.updatedDate):product.updatedDate,
          };
        });
        this.exportExcel(dataToExport);
        
}

convertDateTimeFormat(inputDateTime: string) {  // while export to excel display UTC format
  const date = new Date(inputDateTime);

  // Adjust for timezone offset
  const timezoneOffsetHours = 5; 
  const timezoneOffsetMinutes = 30;
  date.setUTCHours(date.getUTCHours() + timezoneOffsetHours);
  date.setUTCMinutes(date.getUTCMinutes() + timezoneOffsetMinutes);

  // Format date
  const day = date.getUTCDate().toString().padStart(2, '0');
  const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
  const year = date.getUTCFullYear();
  const formattedDate = `${day}-${month}-${year}`;

  // Format time in UTC
  const hours = date.getUTCHours().toString().padStart(2, '0');
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');
  const formattedTime = `${hours}:${minutes} UTC`;

  return `${formattedDate} ${formattedTime}`;
}
exportExcel(SelectedRecords: any) {
  import('xlsx').then((xlsx) => {
    const worksheet = xlsx.utils.json_to_sheet(SelectedRecords);
    const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "Products");
  });
}

saveAsExcelFile(buffer: any, fileName: string): void {
  this.auditLogService.logExport('Sponsor Products',this.SponserId || AuditIdentifier.SponsorDetails,AuditLogModule.Sponsorservice,fileName);

  let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  let EXCEL_EXTENSION = FileExtension.ExportExtention;
  const data: Blob = new Blob([buffer], {
    type: EXCEL_TYPE
  });
  FileSaver.saveAs(data, fileName);
}
 



changedProductsInfo:any;
auditModelForProducts=new AuditLogModel();
   
onCancelProduct(){
    this.displayAddProductDialog=false;
}

}
